import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListEmailAddressCell } from '@app/feature/user/user-list/user-list-email-address.cell';
import { UserListEmailAddressHeader } from '@app/feature/user/user-list/user-list-email-address.header';

export const CustomerUserListEmailAddressColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['emailAddress']
> = {
  enableSorting: false,
  header: UserListEmailAddressHeader,
  cell: UserListEmailAddressCell,
};
